// removed by extract-text-webpack-plugin
module.exports = {"PaywallContent":"_1NroktnHG77PH7lpQc_kUx","description":"_2ZeGVK7p-e9dQNQC9VAl-Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Paywalls/PaywallContent/PaywallContent.css
// module id = 481
// module chunks = 0